// Sliders
(function ($) {
  $(function(){
    $slider = $('#quiz-results-tip-sheet-slider');
    $slider
      .on('init', function(slick) {
        toggleHasArrowsClass();
      })
      .on('breakpoint', function(event, slick) {
        toggleHasArrowsClass();
      })
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        mobileFirst: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          }
        ]
      })
    ;

    function toggleHasArrowsClass() {
      $slider.toggleClass('slick-has-arrows', $slider.find('.slick-prev').length ? true : false);
    }
  });
})(jQuery);

// App code modal
(function ($) {
  $(function(){
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('qr') == '1') {
      const message = $('#mp-quiz-code-modal').first().html();

      Drupal.showModal({
        message,
        className: 'mp-quiz-code-modal',
        size: 'large'
      });
    }
  });
})(jQuery);
